import { useEffect } from "react";
import {
  faqEventEmitter,
  FaqEventPayload,
} from "../../../components/features/faq/faq-event-emitter";
import { useMmGtm } from "../mm-gtm-context";

export const MmGtmEventFaq = () => {
  const { pusher } = useMmGtm();

  useEffect(() => {
    const handleEvent = (params: FaqEventPayload["faqClicked"]) => {
      pusher({
        event: "clicked_faq",
        ecommerce: {
          faqClicked: {
            question: params.question,
            variant: params.variant,
            productSku: params.productSku,
            category: params.category,
          },
        },
      });
    };

    faqEventEmitter.on("faqClicked", handleEvent);
    return () => {
      faqEventEmitter.off("faqClicked", handleEvent);
    };
  }, []);

  return null;
};
